"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownButton = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Button_1 = require("../Button/Button");
/**
 * @internal
 */
exports.DropdownButton = function (_a) {
    var id = _a.id, className = _a.className, value = _a.value, _b = _a.title, title = _b === void 0 ? value : _b, disabled = _a.disabled, isOpen = _a.isOpen, _c = _a.isSmall, isSmall = _c === void 0 ? true : _c, iconLeft = _a.iconLeft, onClick = _a.onClick;
    var buttonClasses = classnames_1.default("gd-button-primary", "button-dropdown", "dropdown-button", {
        "gd-button-small": isSmall,
        "is-dropdown-open": isOpen,
        "is-active": isOpen,
    }, className);
    return (react_1.default.createElement(Button_1.Button, { id: id, title: title && typeof title === "string" ? title : undefined, className: buttonClasses, value: value, iconLeft: iconLeft, iconRight: isOpen ? "gd-icon-navigateup" : "gd-icon-navigatedown", disabled: disabled, onClick: onClick }));
};
//# sourceMappingURL=DropdownButton.js.map